import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextArea, Popup } from '_atoms';
import { Typography } from '_atoms/Typography';
import { BUTTON_TEXT } from 'constants/text';
import './style.scss';

export const PopupCompleteReminder = ({ open, onClose, onSave }) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  const onChangeComment = e => setComment(e.target.value);
  const onComplete = () => onSave(comment);
  return (
    <Popup
      open={open}
      title={t('translation:popup_complete_reminder.title')}
      className="complete-reminder"
      cancelButtonProps={{
        children: BUTTON_TEXT.CANCEL,
        onClick: onClose,
      }}
      okButtonProps={{
        children: BUTTON_TEXT.COMPLETE,
        disabled: !comment,
        onClick: onComplete,
      }}
    >
      <Typography.Text className="complete-reminder__warning">
        {t('translation:popup_complete_reminder.text_confirm_complete')}
      </Typography.Text>
      <TextArea
        label={t('translation:popup_complete_reminder.label_comment')}
        value={comment}
        placeholder={t('translation:popup_complete_reminder.placeholder_comment')}
        onChange={onChangeComment}
      />
    </Popup>
  );
};
